// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-toggle[data-v-cbcae5f8]:after{content:normal}.sitewide--mobile a[data-v-cbcae5f8]{display:block}.sitewide--mobile a img[data-v-cbcae5f8]{height:auto;width:100vw}@media(min-width:768px){.sitewide[data-v-cbcae5f8]{content-visibility:auto}.sitewide--mobile[data-v-cbcae5f8]{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
